import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
import { SearchGateHomeContent } from '../../SearchGateHome';
import { ViewMode } from '../../../types';
export const FunnelGateHomePage = _ref => {
  let {
    handlers,
    externalViewer
  } = _ref;
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      enabledActions: ['alreadyAssignedToThisSite', 'alreadyAssigned', 'floatingDomain'],
      handlers,
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      },
      uiConfig: {
        fullPage: true
      }
    }
  }, /*#__PURE__*/React.createElement(SearchGateHomeContent, {
    hideBackButton: true,
    viewMode: ViewMode.FUNNEL_GATE
  }));
};
//# sourceMappingURL=FunnelGateHomePage.js.map